import PazienteAccettazioneList from "./pages/PazienteAccettazioneList.vue";
import PazienteAccettazioneEdit from "./pages/PazienteAccettazioneEdit.vue";
import PazienteAccettazioneView from "./pages/PazienteAccettazioneView.vue";

export default {
    PazienteAccettazioneList,
    PazienteAccettazioneEdit,
    PazienteAccettazioneView,
};
